import { render, staticRenderFns } from "./PlansListPriceTypes.vue?vue&type=template&id=7d65e69f"
import script from "./PlansListPriceTypes.vue?vue&type=script&lang=js"
export * from "./PlansListPriceTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports